var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", { attrs: { name: "Companies" } }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: {
                    title: "Companies",
                    "sub-title":
                      "Manage all companies registered in GreenLists",
                    "with-footer": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header-right",
                      fn: function () {
                        return [
                          _c("b-form-select", {
                            staticClass: "w-auto",
                            attrs: { options: _vm.tierLevelOptions },
                            on: { change: () => _vm.loadCompanies() },
                            model: {
                              value: _vm.filters.tier_level,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "tier_level", $$v)
                              },
                              expression: "filters.tier_level",
                            },
                          }),
                          _vm._v(" "),
                          _c("b-form-select", {
                            staticClass: "w-auto ml-2",
                            attrs: { options: _vm.statusOptions },
                            on: { change: () => _vm.loadCompanies() },
                            model: {
                              value: _vm.filters.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "status", $$v)
                              },
                              expression: "filters.status",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c("b-pagination", {
                            staticClass: "admin-pagination mb-0",
                            attrs: {
                              "total-rows": _vm.total_in_pages,
                              "per-page": _vm.per_page,
                              align: "center",
                            },
                            on: { change: _vm.loadCompanies },
                            model: {
                              value: _vm.page,
                              callback: function ($$v) {
                                _vm.page = $$v
                              },
                              expression: "page",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("admin-companies-table", {
                    attrs: {
                      companies: _vm.companies,
                      "sort-by": _vm.sortBy,
                      "sort-desc": _vm.sortDesc,
                    },
                    on: { "sort-changed": _vm.onSortChanged },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }